import { createFileRoute } from '@tanstack/react-router';
import { DemoInvitationsPage } from '@features/admin/demo-invitations';

export const Route = createFileRoute('/admin/demo-invitations')({
  component: RouteComponent,
});

function RouteComponent() {
  return <DemoInvitationsPage />;
}
